module.exports = __webpack_public_path__ + "img/48fa06e.svg";